import { getLiveChatCTAV2Template, getVueLiveChatCTAV2Template } from "../../shortcodes/templates";
import { readLiveChatCTAV2FromNode } from "@/assets/utilities/tinymce/helpers/liveChatCTAV2";

const visualizeLiveChatCTAV2 = content => {
  content.querySelectorAll("live-chat-cta-v2").forEach(node => {
    node.outerHTML = getLiveChatCTAV2Template(readLiveChatCTAV2FromNode(node));
  });
};

const serializeLiveChatCTAV2 = content => {
  content.querySelectorAll("a.button--livechat-cta-v2").forEach(node => {
    node.outerHTML = getVueLiveChatCTAV2Template(readLiveChatCTAV2FromNode(node));
  });
};

export { visualizeLiveChatCTAV2, serializeLiveChatCTAV2 };
